import { i18n } from "../i18n/i18n"; // 10.9FE
/** Menu lateral direito: HUD limpo — Bolsa, Missões, Correio, VIP, Info.
 * 10.6S: Árvore Void REMOVIDA da barra (abre pelo Altar Void no mundo).
 * Loja/Guarda-roupa vivem DENTRO da Bolsa; Mundo abre pelo minimapa. */
export interface MenuBarHandlers {
  onCharacter: () => void;
  onTree: () => void;
  onInventory: () => void;
  onWorld: () => void;
  onShop: () => void;
  onWardrobe: () => void;
  onMissions: () => void;
  onMailbox: () => void;
  onVip: () => void;
  onSettings: () => void;
  onTraining?: () => void; // 10.9BY — toque no indicador de treino abre a tela de Skills
}

export class MenuBar {
  private readonly root: HTMLDivElement;
  private readonly missionDot: HTMLElement;
  private readonly mailDot: HTMLElement;

  constructor(uiRoot: HTMLElement, h: MenuBarHandlers) {
    this.root = document.createElement("div");
    this.root.className = "menu-bar";
    this.root.hidden = true;
    this.root.innerHTML = `
      <button class="mbtn" data-a="inv" aria-label="inventory">🎒<span class="mb-lbl" data-l="inv"></span></button>
      <button class="mbtn" data-a="shop" aria-label="shop">🛒<span class="mb-lbl" data-l="shop"></span></button>
      <button class="mbtn" data-a="missions" aria-label="missions">📜<span class="mb-dot" hidden></span><span class="mb-lbl" data-l="missions"></span></button>
      <button class="mbtn" data-a="mail" aria-label="mailbox">📬<span class="mb-mail-dot" hidden></span><span class="mb-lbl" data-l="mail"></span></button>
      <button class="mbtn vip" data-a="vip" aria-label="VIP">⭐<span class="mb-lbl" data-l="vip"></span></button>
`;
    // 10.9FE — rotulo embaixo de cada icone (antes so emoji: jogador novo nao sabia o que era)
    const fillLbl = (): void => { this.root.querySelectorAll<HTMLElement>(".mb-lbl").forEach((el) => {
      const label = i18n.t(`mbar.${el.dataset.l}`);
      el.textContent = label;
      el.closest("button")?.setAttribute("aria-label", label);
    }); };
    fillLbl();
    i18n.onChange(fillLbl);
    uiRoot.appendChild(this.root);
    this.missionDot = this.root.querySelector(".mb-dot")!;
    this.mailDot = this.root.querySelector(".mb-mail-dot")!;
    this.root.querySelector('[data-a="inv"]')!.addEventListener("click", () => h.onInventory());
    this.root.querySelector('[data-a="shop"]')!.addEventListener("click", () => h.onShop()); // 10.9DG
    this.root.querySelector('[data-a="missions"]')!.addEventListener("click", () => h.onMissions());
    this.root.querySelector('[data-a="mail"]')!.addEventListener("click", () => h.onMailbox());
    this.root.querySelector('[data-a="vip"]')!.addEventListener("click", () => h.onVip());
  }

  show(): void { this.root.hidden = false; }
  hide(): void { this.root.hidden = true; }

  setMissionDot(on: boolean): void {
    this.missionDot.hidden = !on;
  }

  setMailDot(on: boolean): void {
    this.mailDot.hidden = !on;
  }

  /** 10.9BY — indicador "🎯 Treinando Espada · 3h12" (null = esconde). */
  setTraining(_text: string | null): void { /* 10.9DQ — tempo de treino agora aparece no TOTEM do hub, não no menu */ }

  /** Selo de Void Points — mantido para o Game chamar, mas sem botão na barra. */
  setTreeBadge(_n: number): void {
    // sem botão tree na barra; a notificação aparece no altar (banner)
  }
}
